<template>
  <div>
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="所属分类">
        <Cascader
          :data="catagoris"
          v-model="classify_ids"
          trigger="hover"
          style="width:200px;"
          change-on-select
        ></Cascader>
      </FormItem>
      <FormItem label="考试状态">
        <Select v-model="searchCondition.status" style="width:200px;" clearable>
          <Option
            v-for="(item, index) in paperStatus"
            :key="index"
            :value="item.key"
          >{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="考试名称">
        <Input
          v-model="searchCondition.name"
          placeholder="请输入名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </FormItem>
    </Form>
    <Button type="primary" @click="createExam('imitate')" >新增考试</Button>
    <!-- <Dropdown @on-click="createExam">
      <Button type="primary">
        新增考试
        <Icon type="ios-arrow-down"></Icon>
      </Button>
      <DropdownMenu slot="list">
        <DropdownItem name="imitate">模拟考试</DropdownItem>
        <DropdownItem name="formal">正式考试</DropdownItem>
      </DropdownMenu>
    </Dropdown> -->
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/exam/packageSimulation"
        :search="searchCondition"
        @onSelectionChange="onSelectionChange"
        :rowsFormatter="rowsFormatter"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onEdit(row)">编辑</Button>
            <span>-</span>
            <Button type="text" size="small" v-if="row.is_top > 0" @click="onTop(row,0)">取消置顶</Button>
            <Button type="text" size="small" v-else @click="onTop(row,1)">置顶</Button>
            <span>-</span>
            <Button v-if="row.status==3||row.status==2" type="text" size="small" @click="onShelf(1,row.id)">上架</Button>
            <Button v-else type="text" size="small" @click="onShelf(2,row.id)">下架</Button>
            <span>-</span>
            <Button type="text" size="small" :to="{name:'ExamDetail', query:{id: row.id, type: 2}}">学员列表</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onForbidden(row.id)">删除</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button class="btn-margin-right" size="small" @click="onForbidden">删除</Button>
          <Button class="btn-margin-right" size="small" @click="onShelf(1)">上架</Button>
          <Button class="btn-margin-right" size="small" @click="onShelf(2)">下架</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
import { ExamState } from "@/utils/enums";
export default {
  name: "QuestionExamManage",
  data() {
    return {
      paperStatus: ExamState.getOptions(),
      paperType: [{ key: 1, value: "模拟考试" }, { key: 2, value: "正式考试" }],
      catagoris: [],
      classify_ids: [],
      searchCondition: {
        exam_type: 0,
        status: "",
        name: "",
        classify_id : 0,
        init: function() {
          this.exam_type = 0;
          this.status = "";
          this.classify_id = 0;
          this.name = "";
        }
      },
      onlyShowMe: false,
      tableColumns: [
        { title: "考试名称", key: "name", align: "center", minWidth: 180 },
        {
          title: "所属分类",
          key: "classify_name",
          align: "center",
          minWidth: 100
        },
        {
          title: "关联试卷名称",
          key: "exam_name",
          align: "center",
          minWidth: 120
        },
        { title: "状态", key: "exam_state", align: "center", minWidth: 80 },
        {
          title: "更新时间",
          key: "updated_at",
          align: "center",
          minWidth: 160
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 150,
          fixed: "right"
        }
      ],
      selectItems: []
    };
  },
  async created() {
    let catagoris = await this.$http.get("/api/course/classify");
    this.catagoris = catagoris;
  },
  methods: {
    rowsFormatter(rows) {
      let nowTime = Date.parse(new Date());
      rows.forEach(item => {
        item.classify_name = item.classify.title;
        item.updated_at = this.$pub.timestampToTime(item.updated_at);
        if (item.status == 1) {
          item.exam_state = "已上架";
        } else if (item.status == 2) {
          item.exam_state = "已下架";
        } else {
          item.exam_state = "待上架";
        }
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.init();
        this.classify_ids = [];
      }
      this.searchCondition.classify_id = this.classify_ids[1] || this.classify_ids[0];
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(items) {
      this.selectItems = items;
    },
    /**
     * @param {String} id    试卷id
     */
    onForbidden(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要删除该考试吗？</p>",
        onOk: () => {
          this.nextAction(id);
        }
      });
    },
    nextAction(id) {
      let ids = "";
      if (id) {
        ids = id;
      } else {
        this.selectItems.forEach(item => {
          ids += item.id + ",";
        });
        ids = ids.substr(0, ids.length - 1);
      }
      this.$http.delete(`/api/exam/packageSimulation/${ids}`).then(() => {
        this.$Message.deleteSuccess();
        this.search(1);
      });
    },
    createExam(name) {
      this.$router.push({
        name: "QuestionExamAdd",
        query: { name }
      });
    },
    onShelf(status, id) {
      let content = '上架';
      if(status == 2){
        content = '下架';
      }
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要" + content + "该考试吗？</p>",
        onOk: () => {
          this.nextShelfAction(status,id);
        }
      });
    },
    nextShelfAction(status,id) {
      let ids = "";
      if (id) {
        ids = id;
      } else {
        this.selectItems.forEach(item => {
          ids += item.id + ",";
        });
        ids = ids.substr(0, ids.length - 1);
      }
      this.$http.put(`/api/exam/packageSimulation/status/${ids}`, {status}).then(() => {
          status == 1 && this.$Message.success("上架成功");
          status == 2 && this.$Message.success("下架成功");
          this.search(1);
      });
    },

    onEdit( row ) {
      this.$router.push({
        name: "QuestionExamAdd",
        query: { name, id: row.id }
      });
    },

    onTop( row , status ) {
      this.$http.put(`/api/exam/packageSimulation/top/${row.id}`, {status}).then(() => {
          status == 1 && this.$Message.success("置顶成功");
          status == 0 && this.$Message.success("取消置顶成功");
          this.search(1);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  .modal-item {
    border: 1px solid #eee;
    width: 180px;
    padding: 20px;
    cursor: pointer;
    .modal-item-title {
      text-align: center;
      margin-bottom: 10px;
    }
  }
}
</style>
